import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagsState } from './feature-flags.reducers';

export const selectFeatureFlagsState = createFeatureSelector<FeatureFlagsState>('featureFlags');

export const selectFeatureFlags = createSelector(
  selectFeatureFlagsState,
  (state) => state.featureFlags
);

export const selectFeatureFlag = (flagKey: string) =>
  createSelector(selectFeatureFlags, (featureFlags) => featureFlags?.[flagKey] === true);
